import React from 'react';
import type { FieldValues, UseFormReturn } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import type { DocumentUpload } from '@gcv/shared';
import { Box, FormControl } from '@mui/material';

import { FileContainer, InputLabel, Text } from 'ui';
import { environment } from '../../../environments/environment';

export const CustomFormFileDownload: React.FC<{
  label: string;
  name: string;
  required?: boolean;
  form: UseFormReturn<FieldValues>;
  documentMap: { [id: string]: DocumentUpload };
  requirementId: string;
  orgId?: string;
}> = (props) => {
  const [existingFiles, setExistingFiles] = React.useState<DocumentUpload[]>([]);

  React.useEffect(() => {
    const ids = props.form.getValues()[props.name];
    const docs: DocumentUpload[] = [];

    // Before Multiple files support, Values for File field are different for questionnaires & Templates
    // Questionnaires takes DocumentUpload format && Templates takes just docIds
    // to support multiple files, these different formats are causing problems
    // so Now FormValue is made generic with docIDs as their values

    // Below chain of if else's are for same purpose,
    // to support single docID, single documentUpload & array of docIds(this has from multiple files support

    if (Array.isArray(ids)) {
      ids.forEach((id) => {
        if (typeof id === 'string' && id.length > 0) {
          if (props.documentMap[id]) docs.push(props.documentMap[id]);
        }
        if (typeof id === 'object') {
          docs.push(id);
        }
      });
    } else if (typeof ids === 'string') {
      if (props.documentMap[ids]) docs.push(props.documentMap[ids]);
    } else if (typeof ids === 'object') {
      docs.push(ids);
    }
    setExistingFiles(docs);
  }, [props.form.getValues(props.name)]);

  return (
    <FormControl fullWidth>
      <Box data-cy={props.name}>
        <InputLabel
          dataCy={'input-label'}
          label={props.label}
          name={props.name}
          required={props.required}
          readOnly={true}
          darkLabel
          rules={{}}
        />
      </Box>
      <Controller
        control={props.form.control}
        name={props.name}
        render={({ fieldState: { error } }) => (
          <>
            {!existingFiles.length ? (
              <Box sx={{ paddingTop: '8px' }}>
                <Text content="No files uploaded" type="body3" />
              </Box>
            ) : (
              <Box sx={{ paddingTop: '8px' }}>
                <FileContainer
                  fullWidth
                  multiple
                  disableFileDelete={true}
                  readOnly={true}
                  viewOnly={true}
                  fileBucket={environment.storageConfig.orgDocument}
                  existingS3Files={existingFiles}
                  dataCy="file-container"
                  {...props.form}
                />
              </Box>
            )}
          </>
        )}
      />
    </FormControl>
  );
};
